import React from 'react';
import { useTranslation } from 'react-i18next';

import PageLayout from '@/components/layout/PageLayout';
import { TabList } from '@/components/ui/navigation/TabList';
import { useSecurityGroupingPage } from '@/hooks/securityGrouping/useSecurityGroupingPage';
import { GroupingsTab } from './GroupingsTab';
import { AssignAdministratorsTab } from './AssignAdministratorsTab';
import { AssignEmployeesTab } from './AssignEmployeesTab';
import { AssignedEmployeesTab } from './AssignedEmployeesTab';


export const SecurityGroupingPage: React.FC = () => {
  const { t: translate } = useTranslation();
  const { activeTab, handleBackClick, handleTabChange } = useSecurityGroupingPage();

  const tabs = [
    {
      id: 'groupings',
      label: translate('securityGrouping:tabs.groupings'),
      content: <GroupingsTab />,
    },
    {
      id: 'assignAdministrators',
      label: translate('securityGrouping:tabs.assignAdministrators'),
      content: <AssignAdministratorsTab />,
    },
    {
      id: 'assignEmployees',
      label: translate('securityGrouping:tabs.assignEmployees'),
      content: <AssignEmployeesTab />,
    },
    {
      id: 'assigned',
      label: translate('securityGrouping:tabs.assigned'),
      content: <AssignedEmployeesTab />,
    },
  ];

  return (
    <PageLayout onBackClick={handleBackClick}>
      <div data-testid="security-grouping-page">
        <TabList
          tabs={tabs}
          defaultActiveTab={activeTab}
          onTabChange={handleTabChange}
        />
      </div>
    </PageLayout>
  );
};

export default SecurityGroupingPage;
